import React from 'react';
import './FriendlyAuraBorderEffect.css';

function prefersReducedMotion() {
  if (typeof window === 'undefined' || !window.matchMedia) {
    return false;
  }
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

/**
 * Pulsing blue border around friendly aura providers on the battlefield.
 * Rings grow outward, dissipate, and recreate in a staggered loop.
 */
export function FriendlyAuraBorderEffect({ className = '' }) {
  const reducedMotion = prefersReducedMotion();

  return (
    <div
      className={[
        'friendly-aura-border',
        reducedMotion ? 'friendly-aura-border--static' : '',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
      aria-hidden="true"
    >
      <div className="friendly-aura-border__ring friendly-aura-border__ring--a" />
      <div className="friendly-aura-border__ring friendly-aura-border__ring--b" />
      <div className="friendly-aura-border__ring friendly-aura-border__ring--c" />
    </div>
  );
}

export default FriendlyAuraBorderEffect;
